import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const texts = {
  fr: {
    title: "Merci, votre projet est confirmé !",
    already: "Votre projet était déjà confirmé. Merci !",
    text: "Nos artisans partenaires savent maintenant que votre demande est toujours d'actualité. Vous serez contacté rapidement.",
    home: "Retour à l'accueil",
    errTitle: "Lien invalide",
    errText: "Ce lien de confirmation n'est pas valide ou la demande a été supprimée.",
  },
  nl: {
    title: "Bedankt, uw project is bevestigd!",
    already: "Uw project was al bevestigd. Bedankt!",
    text: "Onze partnervakmensen weten nu dat uw aanvraag nog actueel is. U wordt spoedig gecontacteerd.",
    home: "Terug naar de startpagina",
    errTitle: "Ongeldige link",
    errText: "Deze bevestigingslink is niet geldig of de aanvraag werd verwijderd.",
  },
};

export default function LeadConfirmPage() {
  const { token } = useParams();
  const [state, setState] = useState("loading");
  const [lang, setLang] = useState("fr");
  const [already, setAlready] = useState(false);

  useEffect(() => {
    axios.get(`${API}/leads/confirm/${token}`)
      .then((res) => {
        setLang(res.data.lang === "nl" ? "nl" : "fr");
        setAlready(res.data.already_confirmed);
        setState("success");
      })
      .catch(() => setState("error"));
  }, [token]);

  const t = texts[lang];

  return (
    <div className="min-h-screen bg-white" data-testid="lead-confirm-page">
      <Navbar />
      <section className="pt-32 pb-20 lg:pt-40 lg:pb-32">
        <div className="max-w-xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          {state === "loading" && (
            <Loader2 className="w-10 h-10 animate-spin text-orange-500 mx-auto" data-testid="confirm-loading" />
          )}
          {state === "success" && (
            <div data-testid="confirm-success">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <CheckCircle2 className="w-10 h-10 text-green-600" />
              </div>
              <h1 className="font-heading text-3xl font-bold text-slate-900 mb-3">
                {already ? t.already : t.title}
              </h1>
              <p className="text-slate-600 mb-8">{t.text}</p>
              <Link to={lang === "nl" ? "/nl" : "/"}>
                <Button className="bg-orange-500 hover:bg-orange-600 text-white font-semibold" data-testid="confirm-home-button">
                  {t.home}
                </Button>
              </Link>
            </div>
          )}
          {state === "error" && (
            <div data-testid="confirm-error">
              <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <XCircle className="w-10 h-10 text-red-500" />
              </div>
              <h1 className="font-heading text-3xl font-bold text-slate-900 mb-3">
                {texts.fr.errTitle} / {texts.nl.errTitle}
              </h1>
              <p className="text-slate-600 mb-2">{texts.fr.errText}</p>
              <p className="text-slate-500 mb-8">{texts.nl.errText}</p>
              <Link to="/">
                <Button variant="outline">{texts.fr.home}</Button>
              </Link>
            </div>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
}
